// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React, { Component } from 'react'
import { Mutation } from 'react-apollo'
import { i18n } from '../index'
import withActiveStation from '../station/withActiveStation'
import css from './BudgetPlanning.css'
import { upsertMonthlySalesPlan } from './budgetPlanningQueries'
import BudgetTable from './BudgetTable'
import MonthDisplay from './MonthDisplay'
import type { BudgetPlanItem, ForecastSalesItem, PlanItem } from './types'
import { transformPlannedData } from './utils'
type Props = {
  dailyBudgetData: Array<BudgetPlanItem>
  dailyForecastData: Array<ForecastSalesItem>
  dailyPlanData: Array<PlanItem>
  startDate: string
  selectedOption: any
  stationId: string
  editable: boolean
  toggleEditMode: (...args: Array<any>) => any
  efficiencyFactors: any
  onNoteDialogOpen: (...args: Array<any>) => any
}
type State = {
  dailyBudgetData: Array<BudgetPlanItem>
  dailyPlanData: Array<PlanItem>
}

@withActiveStation
class StatsSection extends Component<Props, State> {
  state = {
    dailyBudgetData: this.props.dailyBudgetData,
    dailyPlanData: this.props.dailyPlanData,
  }
  onAmountChange = (e: Event, date: string, type: string) => {
    const newDailyPlanData = [...this.state.dailyPlanData].map((plan) => {
      if (plan.date !== date) {
        return { ...plan }
      }
      return { ...plan, [type]: Number(e.target.value) }
    })
    this.setState({
      dailyPlanData: newDailyPlanData,
    })
  }

  componentDidUpdate(prevProps: Props) {
    if (
      prevProps.startDate !== this.props.startDate ||
      prevProps.selectedOption.name !== this.props.selectedOption.name
    ) {
      this.setState({
        dailyBudgetData: this.props.dailyBudgetData,
        dailyPlanData: this.props.dailyPlanData,
      })
    }
  }

  getMutationVariables = () => {
    const { stationId, startDate: monthDate } = this.props
    const { dailyPlanData } = this.state
    const mutationVariables: any = {
      stationId,
      monthDate,
    }
    mutationVariables.dailyData = transformPlannedData(dailyPlanData)
    return {
      monthlySalesPlan: mutationVariables,
    }
  }
  onClick = (onMutate: (...args: Array<any>) => any) => {
    const { editable, toggleEditMode } = this.props
    // send mutation if the page is on edit mode and the button is clicked
    editable && onMutate()
    toggleEditMode()
  }

  render() {
    const {
      selectedOption,
      editable,
      stationId,
      startDate,
      currentMonth,
      efficiencyFactors,
      dailyForecastData,
      toggleEditMode,
      onMonthChange,
      onNoteDialogOpen,
    } = this.props
    const { dailyBudgetData, dailyPlanData } = this.state
    const isStationPage = 'Station' === selectedOption.type
    return (
      <Mutation mutation={upsertMonthlySalesPlan} variables={this.getMutationVariables()}>
        {(onMutate) => (
          <React.Fragment>
            <h3 className={css.monthDisplayContainer}>
              {i18n.t('budgetPlanning.plan')}
              <MonthDisplay
                toggleEditMode={toggleEditMode}
                isStationPage={isStationPage}
                onMutate={onMutate}
                currentMonth={currentMonth}
                onMonthChange={onMonthChange}
                startDate={startDate}
                editable={editable}
              />
            </h3>
            <BudgetTable
              onAmountChange={this.onAmountChange}
              editable={isStationPage && editable}
              dailyBudgetData={dailyBudgetData}
              dailyForecastData={dailyForecastData}
              dailyPlanData={dailyPlanData}
              efficiencyFactors={efficiencyFactors}
              stationId={stationId}
              selectedOptionId={selectedOption.id}
              isStationPage={isStationPage}
              startDate={startDate}
              onNoteDialogOpen={onNoteDialogOpen}
            />
          </React.Fragment>
        )}
      </Mutation>
    )
  }
}

export default StatsSection
